import type {StateCreator} from 'zustand'
import {ViewMode} from '../../components/comments/CommentsContext'

export type CommentsPanelViewSliceOpts = {
  commentsPanelViewMode?: ViewMode
  commentsPanelDetailThreadId?: string
}

export interface CommentsPanelViewSlice {
  /** Which set of comments the docked comments panel is showing. */
  commentsPanelViewMode: ViewMode
  /** The thread the docked comments panel has open in reply detail, if any. */
  commentsPanelDetailThreadId: string | undefined
  commentsPanelViewActions: {
    setCommentsPanelViewMode: (viewMode: ViewMode) => void
    setCommentsPanelDetailThreadId: (threadId: string | undefined) => void
  }
}

export const createCommentsPanelViewSlice =
  ({
    commentsPanelDetailThreadId,
    commentsPanelViewMode = ViewMode.ThreadPreviews,
  }: CommentsPanelViewSliceOpts): StateCreator<
    CommentsPanelViewSlice,
    [['zustand/devtools', never]],
    [],
    CommentsPanelViewSlice
  > =>
  set => ({
    commentsPanelDetailThreadId,
    commentsPanelViewMode,
    commentsPanelViewActions: {
      setCommentsPanelDetailThreadId: threadId => {
        set({commentsPanelDetailThreadId: threadId}, undefined, 'setCommentsPanelDetailThreadId')
      },
      setCommentsPanelViewMode: viewMode => {
        set(
          state => ({
            commentsPanelViewMode: viewMode,
            // Reply detail only exists within the review views, so leaving them drops the selection.
            commentsPanelDetailThreadId:
              viewMode === ViewMode.IssueComments ? undefined : state.commentsPanelDetailThreadId,
          }),
          undefined,
          'setCommentsPanelViewMode',
        )
      },
    },
  })
